export enum SERVICE_STATUS {
  INITIATED,
  IN_PROGRESS,
  USED,
  REJECTED,
}
